import { render, staticRenderFns } from "./devopers.vue?vue&type=template&id=76297b7a&scoped=true&lang=pug"
import script from "./devopers.vue?vue&type=script&lang=js"
export * from "./devopers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76297b7a",
  null
  
)

/* custom blocks */
import block0 from "./devopers.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports